import { apiSlice } from "../../api/ApiService";
import { getHeadersFromRedux } from "../../utility/functions/common-functions";

const manageMilestoneApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMilestonesList: builder.query({
      query: ({ accessToken }: { accessToken: string | null }) => ({
        url: `/api/v1/Administration/milestones`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
      providesTags: [{ type: "MilestoneTask" }],
    }),
    getVideoContent: builder.query({
      query: ({
        taskCode,
        type,
        langauge,
        refetchKey,
      }: {
        taskCode: string;
        type: string;
        langauge: string;
        refetchKey?: number;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = langauge;
        return {
          url: `/api/v1/Patient/${taskCode}/${type}/educational-content`,
          method: "GET",
          headers,
        };
      },
    }),
    getVideoContentForAdmin: builder.query({
      query: ({
        taskCode,
        type,
        langauge,
        refetchKey,
        accessToken,
      }: {
        taskCode: string;
        type: string;
        langauge: string;
        refetchKey?: number;
        accessToken: string;
      }) => {
        return {
          url: `/api/v1/Administration/${taskCode}/${type}/educational-content/${langauge}`,
          method: "GET",
          headers: accessToken && { Authorization: `Bearer ${accessToken}` },
        };
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetMilestonesListQuery,
  useGetVideoContentQuery,
  useGetVideoContentForAdminQuery,
} = manageMilestoneApi;
export default manageMilestoneApi;
